import { z } from "zod";

export const Bedrohung = z.object({
  id: z.number().int().positive(),
  code: z.number().int().positive(),
  name: z.string().min(1).max(500),
  description: z.string().nullable(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Bedrohung = z.infer<typeof Bedrohung>;

export const BedrohungCreate = z.object({
  code: z.number().int().positive().optional(),
  name: z.string().min(1).max(500),
  description: z.string().max(5000).nullable().optional(),
});
export type BedrohungCreate = z.infer<typeof BedrohungCreate>;

export const BedrohungUpdate = BedrohungCreate.partial();
export type BedrohungUpdate = z.infer<typeof BedrohungUpdate>;

export const ListResponse = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
  });
